import { Component, EventEmitter, Output, Input, ViewChild } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { ClipboardService } from 'ngx-clipboard';
import { NgSelectComponent } from '@ng-select/ng-select';
import { filterBanksForDropdown, settingIsOn } from 'src/app/util/bank-usage.util';

@Component({
  selector: 'app-withdraw-modal',
  templateUrl: './withdraw-modal.component.html',
  styleUrls: ['./withdraw-modal.component.scss']
})
export class WithdrawModalComponent {

  @ViewChild("payout") payout: NgSelectComponent

  @Input() set playerUUID(v:any) {
    this.player_uuid = v;
    this.init()
  }
  @Output() closeEvent = new EventEmitter<any>();
  public player_uuid:any;
  public data:any = {};
  public setting:any = {};
  public is_loading:boolean = false;
  public player:any = {};
  public referral_rate:any = 0;
  public banks:any = [];
  public player_banks:any = [];
  public current_company:any = {}
  public is_loading_function:boolean = false;


  constructor(private http: HttpService,  private clipboardApi: ClipboardService) { 
    this.current_company = this.http.getSelecetdCompanyDetail()
    this.companySetting();
  }

  async companySetting() {
    let y:any = await this.http.post("/admin/company/setting");
    this.setting = y.setting;
  }

  async init() {
    this.is_loading = true;
    let y:any = await this.http.post("/admin/player/get/v2", {player_uuid: this.player_uuid})

    this.player = y;
    this.data.player_game_id = null;
    this.data.game_id = null;
    this.data.player_uuid = this.player_uuid;

    this.getBankDetail();
   this.referral_rate = parseFloat(this.player.referral_rate ?? this.current_company.referral_rate);
  }

  async getBankDetail() {
    let y:any = await this.http.post("/admin/player/bank-detail", {...this.data, usage: 'withdraw'})

    // Server already filters by usage; re-filter client-side so the payout-from
    // list is correct even if an older API build ignores usage (idempotent).
    // Opt-in per company: also hide "Do Not Show" (public=0) banks. Default OFF.
    const hideNonPublic = settingIsOn(this.setting && this.setting.panel_hide_nonpublic_banks);
    this.banks = filterBanksForDropdown(y.banks, 'withdraw', hideNonPublic);
    this.player_banks = y.player_banks;

  }


  topupValueChange() {
    this.data.referral_commission = (this.data.amount * this.referral_rate) / 100;

    if(this.setting.credit_calculation_method && this.setting.credit_calculation_method == 'auto') {
      this.data.point = (this.data.amount * parseFloat(this.setting.credit_calculation_rate)) / 100;
    }

  }


  topupOnlyChange() {
    delete this.data.amount;
    delete this.data.deposit_bank;
    delete this.data.point;
  }


  async withdraw() {

    if(!this.data.full_withdraw && ((!this.data.withdraw || this.data.withdraw < 0) && this.data.withdraw !== 0)) {
      this.http.notify("Withdraw amount is required.")
      return;
    }

    if(!this.data.withdraw_only && (!this.data.withdraw_to_account || !this.data.withdraw_from_account)) {
      this.http.notify("Select Account to Withdraw or create new account")
      return;
    }

    if(!this.data.withdraw_only && (this.data.withdraw_to_account == 'new' && (!this.data.withdraw_bank || !this.data.withdraw_account_no))) {
      this.http.notify("Withdraw Bank Name & Account number are required.")
      return;
    } else {
    }

    if(!this.data.withdraw_only &&this.data.enabled_finance_charge && this.data.finance_charge == undefined) {
      this.http.notify("Finance charge option are required.")
      return;
    }

    this.is_loading_function = true;

    let y:any = await this.http.post("/admin/wallet/withdraw", this.data);

    this.is_loading_function = false;

    if(!y.status && y.message) {
      this.http.notify(y.message)
      return;
    }

    await this.close("Withdraw: " + y.amount + "\n")
   
  }

  withdrawValueChange() {
    if(this.setting.credit_calculation_method && this.setting.credit_calculation_method == 'auto') {
      this.data.withdraw_point = -1 * (this.data.withdraw * parseFloat(this.data.credit_calculation_rate)) / 100;
    }

    this.data.actual_pay_to_bank = this.data.withdraw
  }

  copyAccount() {
    
    let bank = this.player_banks.find((v:any) => {
      return v.id == this.data.withdraw_to_account
    })

    if(bank && bank.account) {
      this.clipboardApi.copyFromContent(bank.account)
    }
  }


  fcRateChange() {
    if(this.data.finance_charge == "true") {
      this.data.finance_charge_rate = this.setting.finance_charge_rate;
    } else {
      delete this.data.finance_charge_rate
    }
  }


  createNewAccount() {
    this.data.withdraw_to_account = "new"
    this.payout.close()
  }

  close(val:any = false) {
    this.closeEvent.emit(val)
  }

}
